<div class="buttons-custom-social">
  @if (isKakaoAvailable) {
    <button
      (click)="loginWithSocial('kakao')"
      class="button buttons-custom-social__kakao"
      appTracking="registration.socialLoginKakaoClick"
    >
      {{ 'socialLogin_buttonKakao' | translate }}
    </button>
  }
</div>

@if (isDefaultSocialAvailable) {
  <div class="wrapper">
    <div class="buttons-social">
      @if (isDefaultSocialAvailableForClientID('facebook')) {
        <button
          (click)="loginWithSocial('facebook')"
          class="button buttons-social__facebook"
          appTracking="registration.socialLoginFacebookClick"
        >
          {{ 'socialLogin_buttonFacebook' | translate }}
        </button>
      }
      @if (isDefaultSocialAvailableForClientID('google')) {
        <button
          (click)="loginWithSocial('google')"
          class="button buttons-social__google"
          appTracking="registration.socialLoginGoogleClick"
        >
          {{ 'socialLogin_buttonGoogle' | translate }}
        </button>
      }
      @if (isDefaultSocialAvailableForClientID('apple')) {
        <button
          (click)="loginWithSocial('apple')"
          class="button buttons-social__apple"
          appTracking="registration.socialLoginAppleClick"
        >
          {{ 'socialLogin_buttonApple' | translate }}
        </button>
      }
      @if (isDefaultSocialAvailableForClientID('paypal')) {
        <button
          (click)="loginWithSocial('paypal')"
          class="button buttons-social__paypal"
          appTracking="registration.socialLoginPaypalClick"
        >
          {{ 'socialLogin_buttonPaypal' | translate }}
        </button>
      }
    </div>
    <p class="info">
      {{ 'socialLogin_implicitConsent1_youAgreeToOur' | translate }}
      <a
        [href]="openTermsHref$ | async"
        class="rc-link"
        rel="noopener"
        target="_blank"
        >{{ 'socialLogin_implicitConsent2_marsPrivacyPolicy' | translate }}</a
      >.
      {{ 'socialLogin_implicitConsent3_personalizedExprerience' | translate }}
    </p>
    <div class="separator">
      <span>{{ 'registerApp_or' | translate }}</span>
    </div>
  </div>
}
